// Ids outlive the wording: they ride on the leave events, so past answers stay comparable.
export type ExitReason = 'too_expensive' | 'missing_feature' | 'not_using_enough' | 'switching_competitor' | 'other';

type ExitReasonOption = {
  id: ExitReason;
  /** Sent as the answer to the PostHog survey's choice question, so its choices must match exactly. */
  label: string;
  /** The optional follow-up, asked only where the reason leaves the useful question open. */
  prompt?: string;
  promptHint?: string;
};

// The five of the cancellation design, in its order.
export const EXIT_REASONS: ReadonlyArray<ExitReasonOption> = [
  // No prompt: the next step is the offer, which answers it.
  { id: 'too_expensive', label: 'Too expensive' },
  // No prompt: the next step opens the feature board, which is where the request is written.
  { id: 'missing_feature', label: 'Missing a feature' },
  { id: 'not_using_enough', label: 'Not using it enough' },
  {
    id: 'switching_competitor',
    label: 'Switching to another product',
    prompt: 'Would you mind sharing which product?',
    promptHint: 'It tells us more about what we are missing than anything else'
  },
  {
    id: 'other',
    label: 'Other',
    prompt: 'Anything you would like us to know?',
    promptHint: 'Whatever you think we should hear'
  }
];

export type ExitAnswer = { reason: ExitReason; comment: string };

export const exitReasonOption = (reason?: ExitReason) => EXIT_REASONS.find((option) => option.id === reason);

export const exitReasonLabel = (reason: ExitReason) => exitReasonOption(reason)?.label || '';

/** The comment only counts where the reason asked for one, so switching reasons never sends a stale note. */
export const exitComment = ({ reason, comment }: ExitAnswer) => (exitReasonOption(reason)?.prompt ? comment.trim() : '');
